module.exports = __webpack_public_path__ + "img/benefit-icon_football.92433528.svg";